import __var_0__ from './compile_set.js';
import __var_1__ from './set1d.js';
import __var_2__ from './set2d.js';
import __var_3__ from './set3d.js';
import __var_4__ from './set4d.js';
import __var_5__ from './setnd.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var compile = __var_0__;
var set1d = __var_1__;
var set2d = __var_2__;
var set3d = __var_3__;
var set4d = __var_4__;
var setnd = __var_5__;


// MAIN //

/**
* Returns a method to set an array element.
*
* @private
* @param {PositiveInteger} ndims - number of dimensions
* @param {boolean} codegen - boolean indicating whether to use code generation
* @param {StringArray} mode - specifies how to handle indices which exceed array dimensions
* @returns {Function} method to set an array element
*/
function set( ndims, codegen, mode ) {
	if ( codegen ) {
		return compile( ndims, mode );
	}
	if ( ndims === 1 ) {
		return set1d( mode );
	}
	if ( ndims === 2 ) {
		return set2d( mode );
	}
	if ( ndims === 3 ) {
		return set3d( mode );
	}
	if ( ndims === 4 ) {
		return set4d( mode );
	}
	return setnd( mode );
}


// EXPORTS //
export default set;
